import { apiCreate } from './client'
import { PASSWORD_RESETS_TYPE } from './types'

type RequestOptions = { signal?: AbortSignal }

export interface PasswordResetRequest {
  email: string
  /**
   * The parent is choosing a first password for an account provisioned at
   * checkout, not replacing a forgotten one. The platform words the email
   * accordingly; the link it carries is the same either way.
   */
  createPassword: boolean
}

/**
 * Ask for the email that carries a reset link.
 *
 * The API sends it only when the address belongs to an account, but answers
 * the same 201 either way — so neither this call nor anything a caller shows
 * can confirm which addresses have Codeverse accounts. The link is only ever
 * emailed, never returned.
 */
export async function requestPasswordReset(
  { email, createPassword }: PasswordResetRequest,
  options: RequestOptions = {},
): Promise<void> {
  await apiCreate(
    '/password_resets',
    {
      type: PASSWORD_RESETS_TYPE,
      attributes: { email: email.trim(), create_password: createPassword },
    },
    options,
  )
}
